(function ($, Global) {
	var SearchModel = function () {
		this.term = '';
		this.pagination = 1;
	};

	SearchModel.prototype.getResultsPrimary = function (data, callback) {
		var url = window.location.pathname + '/refresh';

		url = url.replace('//', '/');
		callService(url, data, callback);
	}

	SearchModel.prototype.getResultsSecondary = function (data, callback) {
		var url = window.location.pathname + '/refresh-annexe';

		url = url.replace('//', '/');
		callService(url, data, callback);
	}

	SearchModel.prototype.getAllResults = function (data, callback) {
		var url =  '/ajax/recherche/all';
        if (data.Publication !== undefined) url = data.Publication + url;
        url = window.location.pathname + '/' + url;
        url = url.replace('//', '/');
		callService(url, data, callback);
	}

	function callService(url, data, callback) {
		$.ajaxPost(url, data)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					success: callback
				})
			});
	}

	Global.SearchModel = SearchModel;
}(jQuery, window));